import {
    Box,
    IconButton,
    Menu,
    MenuItem,
    DialogTitle as MuiDialogTitle,
    Tab,
    Tabs,
    Theme,
    Typography,
    WithStyles,
    createStyles,
    makeStyles, withStyles
} from '@material-ui/core';
import Paper, { PaperProps } from '@material-ui/core/Paper';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';
import Draggable from 'react-draggable';


export const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
        padding: '0px'
    },
})((props: any) => (
    <Menu
        transitionDuration={0}
        elevation={0}

        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));

export const StyledMenuItem = withStyles(theme => ({
    root: {
        '&:focus': {
            backgroundColor: theme.palette.primary.main,
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: theme.palette.common.white,
                padding: "1px"
            },
        },
    },
}))(MenuItem);

export const AntTabs = withStyles({
    root: {
        borderBottom: '1px solid #e8e8e8',
    },
    indicator: {
        backgroundColor: '#597DDA',
    }
})(Tabs);

export const AntTab = withStyles((theme: Theme) =>
    createStyles({
        root: {
            textTransform: 'none',
            minWidth: 72,
            // fontWeight: theme.typography.fontWeightRegular,
            marginRight: theme.spacing(4),
            '&:hover': {
                color: '#597DDA',
                opacity: 1,
            },
            '&$selected': {
                color: '#597DDA',
                fontWeight: theme.typography.fontWeightMedium,
            },
            '&:focus': {
                color: '#597DDA',
            },
        },
        selected: {},
    }),
)((props: StyledTabProps) => <Tab disableRipple {...props} />);

interface StyledTabsProps {
    value: number;
    onChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
}

export const StyledTabs = withStyles({
    indicator: {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        padding: "0px",
        '& > span': {
            maxWidth: 40,
            width: '100%',
            backgroundColor: '#635ee7',
        },
    },
})((props: StyledTabsProps) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

interface StyledTabProps {
    label: string;
}

export const StyledTab = withStyles((theme: Theme) =>
    createStyles({
        root: {
            textTransform: 'none',
            color: '#fff',
            // fontWeight: theme.typography.fontWeightRegular,
            fontSize: theme.typography.pxToRem(15),
            marginRight: theme.spacing(1),
            padding: "0px",
            '&:focus': {
                opacity: 1,
            },
        },
    }),
)((props: StyledTabProps) => <Tab disableRipple {...props} />);

interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

export function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            style={{ padding: "0px" }}
        >
            <Box hidden={value !== index}>
                <Typography component="span">{children}</Typography>
            </Box>
        </div>
    );
}

const styles = (theme: Theme) =>
    createStyles({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });

export interface DialogTitleProps extends WithStyles<typeof styles> {
    id: string;
    children: React.ReactNode;
    onClose: () => void;
}

export const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} style={{ cursor: 'move' }} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose} style={{ color: '#597dda' }}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

export function PaperComponent(props: PaperProps) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
}

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        paper: {
            display: 'flex',
            flexDirection: 'column',
            padding: '25px 15px 0px 15px'
        },
        gridList: {
            height: 420,
        },
        root: {
            color: '#597DDA',
            // marginLeft: '15px',
            fontSize: '1rem',
        },
        listItem: {
            paddingRight: '2px',
            paddingLeft: '2px',
            color: "black"
        },
        buttonAlign: {
            alignItems: 'flex-end'
        },
        chipsGreen: {
            backgroundColor: '#61BB47',
            fontWeight: 'bold'
        },
        chipsRed: {
            backgroundColor: '#EE3125',
            fontWeight: 'bold'
        },
        chipsYellow: {
            backgroundColor: '#FABA12',
            fontWeight: 'bold'
        },
        chipsGray: {
            backgroundColor: 'gray',
            fontWeight: 'bold'
        },
        chipsBlack: {
            backgroundColor: 'black',
            fontWeight: 'bold',
            color: 'white'
        },
        rootCheckBox: {
            margin: '10px',
        },
        rootContent: {
            flexGrow: 1,
            backgroundColor: theme.palette.background.paper,
            borderRadius: '3px',
            margin: '10px'
        },
        rootForm: {
            margin: '10px'
        },
        rootFormError: {
            margin: '10px',
            color: 'red !important'
        },
        mdfeActions: {
            textAlign: 'right'
        },
        rootButton: {
            margin: '10px',
            minWidth: '188px'
        },
        rootCancelButton: {
            margin: '10px',
            minWidth: '188px',
            border: '1px solid #597DDA',
            color: '#597DDA'
        },
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: '#fff',
        },
        inputMarginRight: {
            backgroundColor: '#efefef',
            marginRight: '3px'
        },
        inputBlocked: {
            backgroundColor: '#efefef'
        },
        input: {
            backgroundColor: 'transparent'
        },
        inputError: {
            backgroundColor: 'transparent',
            color: 'red'
        },
        rootTab: {
            flexGrow: 1,
            padding: "0px",
        },
        paddingTab: {
            padding: "0px",
        },
        demo1: {
            backgroundColor: theme.palette.background.paper,
        }
    })
);
